export const errorStyles = {
  color: 'error.main',
  '&.Mui-checked': {
    color: 'error.main',
  },
};
